import { Switch } from "antd";
import styles from "./index.module.scss";

const OverrideAntdSwitch = ({ checked, onChange, ...rest }) => {
  return (
    <div className={styles.switch_warp}>
      <Switch checked={checked} onChange={onChange} {...rest} />
    </div>
  );
};

export default OverrideAntdSwitch;
